import React from 'react';
import { MDBCardFooter, MDBRow, MDBCol } from 'mdb-react-ui-kit';

function Footer({ leftText, rightText, footerLeftClass = "", footerRightClass = "" }) {
    return (
        <MDBCardFooter className='rounded-0'>
            <MDBRow className="g-0">
                <MDBCol className={`col-6 ${footerLeftClass}`}>{leftText}</MDBCol>
                <MDBCol className={`col-6 ${footerRightClass}`}>{rightText}</MDBCol>
            </MDBRow>
        </MDBCardFooter>
    );
}

export default Footer;